import { render, staticRenderFns } from "./AvatarAndName.vue?vue&type=template&id=59204e68"
import script from "./AvatarAndName.vue?vue&type=script&lang=js"
export * from "./AvatarAndName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports